import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'
import {
    CaseAutomaticNotificationTriggerModalState,
    Condition,
    ConditionItem,
    ConditionType,
    ConditionTypeEnum,
    initialCaseAutomaticNotificationTriggerModalState
} from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/components/case-automatic-notification-trigger-modal/case-automatic-notification-trigger-modal.model'
import {
    CaseAutomaticNotificationTriggerCreateRequest,
    CaseAutomaticNotificationTriggerPatchInBatchRequest,
    CaseAutomaticNotificationTriggerResponse
} from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-case-automatic-notification-trigger/configuration-case-automatic-notification-trigger.dto'
import { Nullable } from '@/shared/types/app.types'
import { CommonPetitionerResponse, EnumResponse } from '@/api/services/common.dto'
import { configurationPetitionerService } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-petitioner/configuration-petitioner.service'
import { ConfigurationDepartmentResponse } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-department/configuration-department.dto'
import { configurationDepartmentService } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-department/configuration-department.service'
import { CommonMorphologicCodeResponse } from '@/api/services/common/morphologic-code/common-morphologic-code.dto'
import { commonMorphologicCodeService } from '@/api/services/common/morphologic-code/common-morphologic-code.service'
import { configurationCaseAutomaticNotificationActionTypeService } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-case-automatic-notification-action-type/configuration-case-automatic-notification-action-type.service'
import { predefinedCustomNotificationConfigurationService } from '@/modules/configurationModule/detail/notifications/services/predefined-custom-notification/predefined-custom-notification.service'
import { PredefinedCustomNotificationResponse } from '@/modules/configurationModule/detail/notifications/services/predefined-custom-notification/predefined-custom-notification.dto'
import { CommonFilterModel } from '@/api/resources/common/shared/models/common.models'
import { GridUtils } from '@/shared/util/grid-utils'

@Component
export default class CaseAutomaticNotificationTriggerModal extends Vue {
    @Ref() readonly caseAutomaticNotificationTriggerModal!: BModal
    @Ref() readonly conditionCombo!: any

    @Prop(String) readonly actionTitle!: string

    private get _createRequest(): CaseAutomaticNotificationTriggerCreateRequest {
        let petitionerIds: number[] = []
        let departmentIds: number[] = []
        let comprehensiveDiagnosisMorphologicCodeIds: number[] = []
        let sampleMorphologicCodeIds: number[] = []

        for (const condition of this.state.conditions) {
            const conditionItemIds = condition.conditionItems.map(conditionItem => conditionItem.id)

            switch (condition.conditionType.code) {
            case ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES:
                comprehensiveDiagnosisMorphologicCodeIds =
                    comprehensiveDiagnosisMorphologicCodeIds.concat(conditionItemIds)
                break
            case ConditionTypeEnum.DEPARTMENTS:
                departmentIds =
                    departmentIds.concat(conditionItemIds)
                break
            case ConditionTypeEnum.PETITIONERS:
                petitionerIds =
                    petitionerIds.concat(conditionItemIds)
                break
            case ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES:
                sampleMorphologicCodeIds =
                    sampleMorphologicCodeIds.concat(conditionItemIds)
                break
            }
        }

        return {
            actionType: this.state.caseAutomaticNotificationTrigger.actionType!.code,
            active: !!this.state.caseAutomaticNotificationTrigger.active,
            comprehensiveDiagnosisMorphologicCodeIds,
            comprehensiveDiagnosisTextCondition: this.state.caseAutomaticNotificationTrigger.comprehensiveDiagnosisTextCondition,
            departmentIds,
            isCaseStatusValidatedCondition: this.state.caseAutomaticNotificationTrigger.isCaseStatusValidatedCondition,
            name: this.state.caseAutomaticNotificationTrigger.name,
            petitionerIds,
            predefinedCustomNotificationId: this.state.caseAutomaticNotificationTrigger.predefinedCustomNotification?.id,
            sampleAdditionalReportTextCondition: this.state.caseAutomaticNotificationTrigger.sampleAdditionalReportTextCondition,
            sampleDiagnosisTextCondition: this.state.caseAutomaticNotificationTrigger.sampleDiagnosisTextCondition,
            sampleMacroTextCondition: this.state.caseAutomaticNotificationTrigger.sampleMacroTextCondition,
            sampleMicroTextCondition: this.state.caseAutomaticNotificationTrigger.sampleMicroTextCondition,
            sampleMorphologicCodeIds
        }
    }
    @Emit()
    create(): CaseAutomaticNotificationTriggerCreateRequest {
        return this._createRequest
    }
    @Emit()
    update(): CaseAutomaticNotificationTriggerPatchInBatchRequest {
        return {
            ...this._createRequest,
            id: this.state.caseAutomaticNotificationTrigger.id!
        }
    }

    state: CaseAutomaticNotificationTriggerModalState
    constructor() {
        super()
        this.state = initialCaseAutomaticNotificationTriggerModalState()
    }

    private get _updateMode(): boolean {
        return !!this.state.caseAutomaticNotificationTrigger?.id
    }

    get hasConditionType(): boolean {
        return !!this.state.conditionType
    }

    private get _isSelectedConditionsInConditions(): boolean {
        const condition =
            this.state.conditions.find(condition => condition.conditionType.code === this.state.conditionType?.code)
        if (condition) {
            return condition.conditionItems.some(conditionItem => {
                switch (this.state.conditionType?.code) {
                case ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES:
                    return this.state.comprehensiveDiagnosisMorphologicCodes.some(
                        comprehensiveDiagnosisMorphologicCodes =>
                            comprehensiveDiagnosisMorphologicCodes.id === conditionItem.id)
                case ConditionTypeEnum.DEPARTMENTS:
                    return this.state.departments.some(
                        department =>
                            department.id === conditionItem.id)
                case ConditionTypeEnum.PETITIONERS:
                    return this.state.petitioners.some(
                        petitioner =>
                            petitioner.id === conditionItem.id)
                case ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES:
                    return this.state.sampleMorphologicCodes.some(
                        sampleMorphologicCode =>
                            sampleMorphologicCode.id === conditionItem.id)
                }
            })
        }
        return false
    }
    get canAddConditions(): boolean {
        return !!this.state.conditionType && !this._isSelectedConditionsInConditions
    }

    get conditionsSelected(): ConditionItem[] {
        switch (this.state.conditionType?.code) {
        case ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES:
            return this.state.comprehensiveDiagnosisMorphologicCodes
        case ConditionTypeEnum.DEPARTMENTS:
            return this.state.departments
        case ConditionTypeEnum.PETITIONERS:
            return this.state.petitioners
        case ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES:
            return this.state.sampleMorphologicCodes
        default:
            return []
        }
    }
    set conditionsSelected(value: ConditionItem[]) {
        switch (this.state.conditionType?.code) {
        case ConditionTypeEnum.PETITIONERS:
            this.state.petitioners = value as CommonPetitionerResponse[]
            break
        case ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES:
            this.state.comprehensiveDiagnosisMorphologicCodes = value as CommonMorphologicCodeResponse[]
            break
        case ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES:
            this.state.sampleMorphologicCodes = value as CommonMorphologicCodeResponse[]
            break
        case ConditionTypeEnum.DEPARTMENTS:
            this.state.departments = value as ConfigurationDepartmentResponse[]
            break
        }
    }

    get conditionMinCharsToFilter(): number {
        switch (this.state.conditionType?.code) {
        case ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES:
        case ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES:
            return 3
        default:
            return 2
        }
    }

    get showConditions(): boolean {
        return !!this.state.conditions.length
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        const conditionsHasBeenChanged: boolean =
            JSON.stringify(this.state.conditions) !== JSON.stringify(this.state.originalConditions)
        return (!hasErrors && isDirty) || conditionsHasBeenChanged
    }

    private _initialConditions(): Condition[] {
        return [
            {
                conditionType: {
                    code: ConditionTypeEnum.PETITIONERS,
                    translatedName: this.$tc('configuration.sections.petitioners', 2)
                },
                conditionItems: this.state.petitioners
            },
            {
                conditionType: {
                    code: ConditionTypeEnum.DEPARTMENTS,
                    translatedName: this.$tc('configuration.sections.department', 2)
                },
                conditionItems: this.state.departments
            },
            {
                conditionType: {
                    code: ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES,
                    translatedName: this.$tc('configuration.sections.sampleMorphologicCode', 2)
                },
                conditionItems: this.state.sampleMorphologicCodes
            },
            {
                conditionType: {
                    code: ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES,
                    translatedName: this.$tc('configuration.sections.comprehensiveDiagnosisMorphologicCode', 2)
                },
                conditionItems: this.state.comprehensiveDiagnosisMorphologicCodes
            }
        ]
    }

    get conditionTypes(): ConditionType[] {
        return this.state.conditions.map(condition => condition.conditionType)
    }

    private async _loadPetitioners(query: string): Promise<CommonPetitionerResponse[]> {
        const response =
            await this.$_toCallSecure(
                configurationPetitionerService.search({
                    nameFragments: query,
                    active: true,
                    size: 100
                }))
        return response?.content ?? []
    }
    private async _getDepartmentsByName(query: string): Promise<ConfigurationDepartmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'name': GridUtils.getTextFilterModel('contains', query)
        }
        const response =
            await this.$_toCallSecure(
                configurationDepartmentService.paginator(filterModel))
        return response?.content ?? []
    }
    private async _searchMorphologicCodes(query: string): Promise<CommonMorphologicCodeResponse[]> {
        const response =
            await this.$_toCallSecure(
                commonMorphologicCodeService.searchMorphologicCodes(query))
        return response ?? []
    }
    async getConditions(query?: string): Promise<ConditionItem[]> {
        if (query) {
            switch (this.state.conditionType?.code) {
            case ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES:
            case ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES:
                return this._searchMorphologicCodes(query)
            case ConditionTypeEnum.DEPARTMENTS:
                return this._getDepartmentsByName(query)
            case ConditionTypeEnum.PETITIONERS:
                return this._loadPetitioners(query)
            default:
                return []
            }
        }
        return []
    }

    getConditionItemLabel(conditionItem: ConditionItem): string {
        return this.getConditionItemLabelByConditionType(conditionItem, this.state.conditionType)
    }
    getConditionItemLabelByConditionType(conditionItem: ConditionItem, conditionType: Nullable<ConditionType>): string {
        switch (conditionType?.code) {
        case ConditionTypeEnum.COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES:
        case ConditionTypeEnum.SAMPLE_MORPHOLOGIC_CODES:
            const morphologicCode = conditionItem as CommonMorphologicCodeResponse
            return `${morphologicCode.code} | ${morphologicCode.description}`
        case ConditionTypeEnum.DEPARTMENTS:
            const department = conditionItem as ConfigurationDepartmentResponse
            return `${department.name} | ${department.center.name}`
        case ConditionTypeEnum.PETITIONERS:
            const petitioner = conditionItem as CommonPetitionerResponse
            return petitioner.fullName
        default:
            return ''
        }
    }

    async getCustomNotificationActionTypes(): Promise<EnumResponse[]> {
        const response =
            await this.$_toCallUnique(
                configurationCaseAutomaticNotificationActionTypeService.getCustomNotificationActionTypes())
        return response ?? []
    }

    async getPredefinedCustomNotifications(): Promise<PredefinedCustomNotificationResponse[]> {
        const response =
            await this.$_toCallSecure(
                predefinedCustomNotificationConfigurationService.paginator(
                    undefined,
                    undefined,
                    this.$store.getters.labId))
        return response?.content ?? []
    }

    /// MODAL OPERATIONS ///

    async show(caseAutomaticNotificationTrigger?: CaseAutomaticNotificationTriggerResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialCaseAutomaticNotificationTriggerModalState()
        if (caseAutomaticNotificationTrigger) {
            this.state.caseAutomaticNotificationTrigger = caseAutomaticNotificationTrigger

            this.state.comprehensiveDiagnosisMorphologicCodes = caseAutomaticNotificationTrigger.comprehensiveDiagnosisMorphologicCodes
            this.state.departments = caseAutomaticNotificationTrigger.departments
            this.state.petitioners = caseAutomaticNotificationTrigger.petitioners
            this.state.sampleMorphologicCodes = caseAutomaticNotificationTrigger.sampleMorphologicCodes
        }

        this.state.conditions = this._initialConditions()
        this.state.originalConditions = this._initialConditions()

        this.caseAutomaticNotificationTriggerModal.show()
    }

    hide(): void {
        this.caseAutomaticNotificationTriggerModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this._updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }

            this.hide()
        }
    }

    /// MODAL EVENT HANDLERS ///

    addConditionItems(): void {
        const condition =
            this.state.conditions.find(condition => condition.conditionType.code === this.state.conditionType?.code)
        if (condition) {
            condition.conditionItems = condition.conditionItems.concat(this.conditionsSelected)
        }
    }
    deleteConditionItem(condition: Condition, conditionItem: ConditionItem): void {
        const conditionItems =
            condition.conditionItems.filter(condition => condition.id !== conditionItem.id)
        if (conditionItems) {
            condition.conditionItems = conditionItems
        }
    }

    onSelectConditionType(): void {
        this.conditionCombo.clearInternalOptions()
    }
}
